import React, { useState, useMemo, useEffect, useRef } from "react"
import {
	Box,
	FormControl,
	InputAdornment,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
	makeStyles,
	useTheme,
	Paper,
	TextField,
	Grid,
	Typography,
	Button,
	Popper,
	Fade,
	Tooltip,
	Divider,
} from "@material-ui/core"
import { Add, KeyboardArrowDown, Search as SearchIcon, Send, Edit as EditIcon } from "@material-ui/icons"
import { useTranslation } from "react-i18next"
import { Skeleton } from "@material-ui/lab"
import { ReviewForm } from "../ReviewForm"
import { useParams, useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
	createReviewRequestReset,
	getReviewListRequest,
	getReviewRequest,
	isReviewUpdateTrigger,
	reSetReview,
	resetReviewForm,
	setIsCaseAdmin,
	setReview,
	setReviewAsignee,
	setReviewAssigneeMap,
	setReviewCurrentAsignee,
	setReviewFormOpen,
} from "../../../actions/reviewActions"
import useStyles from "./styles"
import { roles } from "../../../data/roles"

const MenuProps = {
	PaperProps: {
		style: {
			maxWidth: 390,
			minWidth: 390,
			maxHeight: 300,
			minHeight: 300,
			boxShadow: "none",
			border: "1px solid rgba(44, 53, 51, 0.12)",
			overflowY: "hidden",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "right",
	},
	// transformOrigin: {
	// 	vertical: "bottom",
	// 	horizontal: "left",
	// },
	getContentAnchorEl: null,
}

const search = (data, searchText, nameField, shouldInclude = false) =>
	shouldInclude && data?.[nameField]?.toLowerCase()?.indexOf(searchText.toLowerCase()) > -1

const ReviewDropdown = ({
	isLoading = false,
	selectedSearch,
	filesCount = 0,
	open,
	setOpen,
	loadSavedSearch = () => {},
	clearSearchSection,
	mapDataToState = () => {},
	hideCreateReviewButton = false,
	reviewSelectedCallback = () => {},
}) => {
	const [t] = useTranslation("global")
	const classes = useStyles()
	const theme = useTheme()
	const poperRef = useRef(null)
	const dispatch = useDispatch()
	const history = useHistory()

	const isSaving = useSelector((state) => state.review?.isSaving)
	const isSaved = useSelector((state) => state.review?.isSaved)
	const reviewList = useSelector((state) => state.review?.list)
	const isListLoading = useSelector((state) => state.review?.listLoading)
	const selectedReview = useSelector((state) => state.review?.review)
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const user = useSelector((state) => state?.authtentication?.user?.user)
	const is_case_admin = useSelector((state) => state.review?.is_case_admin)
	const isUpdateTrigger = useSelector((state) => state.review?.isUpdateTrigger)
	const isCaseUser = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_User)
	const isCaseAdmin = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_Administrator)
	const isSuperUser = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Super_User)
	const isSystemAdmin = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.System_Administrator)

	const [list, setList] = useState([])

	const [isReviewlistOpen, setIsReviewlistOpen] = useState(false)
	const [reviewSelect, setReviewSelect] = useState()
	const [searchText, setSearchText] = useState("")

	const filteredList = useMemo(() => list?.filter((option) => search(option, searchText, "name")), [list, searchText])
	const createdByYou = useMemo(
		() => list?.filter((option) => search(option, searchText, "name", user?.userid === option?.owner_id)),
		[list, searchText]
	)

	const assignedToYou = useMemo(
		() =>
			list?.filter((option) =>
				search(
					option,
					searchText,
					"name",
					user?.userid !== option?.owner_id || (user?.userid === option?.owner_id && option?.is_assigned_to_owner)
				)
			),
		[list, searchText]
	)

	useEffect(() => {
		dispatch(getReviewListRequest()) //get the review list onLoad
	}, [selectedBaseId])

	useEffect(() => {
		if (isSaved) {
			dispatch(createReviewRequestReset()) //create review form clear
			dispatch(getReviewListRequest()) //get the review list to update
			handleClick()
		}
	}, [isSaved])

	useEffect(() => {
		if (open && isReviewFormOpen === false) {
			//auto close if user clicks on "view all documents"
			setOpen((prev) => false)
		}
	}, [isReviewFormOpen])

	useEffect(() => {
		if (reviewList?.length > 0) {
			setList((prevList) => reviewList)
		} else {
			setList((prevList) => [])
		}
	}, [reviewList])

	useEffect(() => {
		if (history?.location?.state?.reviewId && createdByYou?.length > 0 && !history?.location?.state?.fromNotifications) {
			const reviewId = history?.location?.state?.reviewId
			handleReviewSelect(reviewId, true)
		} else if (history?.location?.state?.reviewId && history?.location?.state?.fromNotifications) {
			const reviewId = history?.location?.state?.reviewId
			handleReviewSelect(reviewId, false)
		}
	}, [createdByYou, history?.location?.state?.reviewId])

	const handleReviewDropdown = () => {
		setIsReviewlistOpen((prev) => !isReviewlistOpen)
	}

	const handleClear = () => {
		setSearchText("")
	}

	const handleClick = () => {
		//onClose
		if (open) {
			/**
			 * If user has role is_case_admin and he is the owner of that review  => means review is selected for Edit
			 * then will clear only reviewCurrentAsignee
			 * if not then will clear reviewCurrentAsignee, reviewAssignee, assigneeMap
			 */
			dispatch(resetReviewForm({ is_case_admin }))
			dispatch(setReviewFormOpen(false))
			dispatch(isReviewUpdateTrigger(false))
			setSearchText("")
			/**
			 * if isUpdateTrigger is true then we need to reset the search form
			 * As isUpdateTrigger apply search to the form
			 **/
			if (isUpdateTrigger) {
				clearSearchSection()
			}

			//reload the selected review
			// if (selectedReview?.id) {
			// 	setReviewSelect(selectedReview?.id)
			// 	dispatch(getReviewRequest({ id: selectedReview?.id, is_case_admin }))
			// 	const review = getReviewById(reviewList, selectedReview?.id)
			// 	if (review) {
			// 		dispatch(setReview(review))
			// 	}
			// }
		} else {
			//onOpen(create review) store the jobId in redux store
			dispatch(setReviewFormOpen(true))
		}
		setOpen((prev) => !prev)
	}

	const handleReviewSelect = (id, is_case_admin = false) => {
		setReviewSelect(id)
		//dispatch(getReviewRequest({ id, is_case_admin }))
		dispatch(setIsCaseAdmin(is_case_admin))
		//---clear the previous selection start---
		dispatch(setReviewAsignee({}))
		dispatch(setReviewCurrentAsignee(""))
		dispatch(setReviewAssigneeMap(new Map()))
		//---clear the previous selection end---
		const review = getReviewById(reviewList, id)
		if (review) {
			dispatch(setReview(review))
		}
	}

	/** 
	 * Due to some custom development on reviewDropdown we are not using the default handleReviewChange
	 * and for edit review button its added on searchSection
	const handleEditReview = (id) => {
		console.log("editId: ", id)
	}

	const handleReviewChange = (e) => {
		setReviewSelect(e.target.value)
		dispatch(getReviewRequest(e.target.value))
		const review = getReviewById(reviewList, e.target.value)
		if (review) {
			dispatch(setReview(review))
		}
	}
	*/

	const getReviewById = (reviewList, id) => {
		return reviewList?.find((review) => review?.id === id)
	}

	// id used for Popper
	const id = open ? "transitions-popper" : undefined

	return (
		<>
			<Box m={1} className={classes.box}>
				<FormControl className={classes.form} fullWidth size="small" variant="outlined">
					<Tooltip title={selectedReview?.name ? selectedReview.name : ""} placement="top" arrow>
						<InputLabel
							shrink={false}
							className={`input-label-searches ${classes.reviewLabel}`}
							onClick={() => setIsReviewlistOpen((prev) => !isReviewlistOpen)}
							style={{ cursor: "text" }}
						>
							{selectedReview?.name ? selectedReview.name : t("review.review")}
						</InputLabel>
					</Tooltip>
					<Select
						open={isReviewlistOpen}
						onClose={handleClear}
						onClick={handleReviewDropdown}
						ref={poperRef}
						variant="outlined"
						MenuProps={MenuProps}
						labelId="review-select-label"
						id="qa-review-select"
						IconComponent={KeyboardArrowDown}
						className={`qa-review ${classes.select} `}
						value={reviewSelect}
						disabled={isReviewFormOpen}
						//onChange={handleReviewChange}
					>
						{isListLoading &&
							Array(9)
								.fill()
								.map((data, i) => (
									<MenuItem key={i} value={""}>
										<Skeleton variant="rounded" width={486} height={41} />
									</MenuItem>
								))}

						{/* {!isLoading && list.length <= 0 && (
							<ListItemText className="no-data-found-item" primary={t("filterConceptDropdown.noDataFound")} />
						)} */}

						{/* {reviewList.map((option, i) => (
							<MenuItem key={option?.id} value={option?.id} className={`${classes.list} qa-review-list-item-${i}`}>
								<Grid item style={{ minWidth: "250px", maxWidth: "250px" }}>
									<Typography
										style={{ ...theme.typography.body2, fontWeight: 400 }}
										nowrap
										className="typography-ellipsis"
									>
										{option?.name}
									</Typography>
								</Grid>
							</MenuItem>
						))} */}

						{!isListLoading && (
							<>
								<div className={classes.header}>
									<Paper className={classes.card} elevation={0}>
										<TextField
											className={`qa-review-search-field ${classes.search}`}
											size="small"
											autoFocus
											placeholder={t("review.search")}
											fullWidth
											onChange={(e) => setSearchText(e.target.value)}
											onKeyDown={(e) => {
												if (e.key !== "Escape") {
													e.stopPropagation()
												}
											}}
											onClick={(e) => {
												e.stopPropagation()
											}}
											margin="none"
											variant="standard"
											InputProps={{
												disableUnderline: true,
												startAdornment: (
													<InputAdornment className={classes.searchIcon} position="start">
														<SearchIcon
															style={{ width: "16px", height: "16px", color: theme.palette.text.primary }}
														/>
													</InputAdornment>
												),
											}}
										/>
									</Paper>
								</div>

								<div className={classes.listScroll}>
									{isCaseAdmin && (
										<Typography
											onClick={(e) => {
												e.stopPropagation()
											}}
											className={classes.listTitle}
										>
											{t("review.createdByYou")}
										</Typography>
									)}

									{isCaseAdmin &&
										(!isListLoading && createdByYou.length > 0 ? (
											<>
												{createdByYou?.map((option, i) => (
													<MenuItem
														key={option?.id}
														value={option?.id}
														className={`${classes.list} qa-review-list-item-${i} ${
															selectedReview?.id === option?.id && is_case_admin ? "Mui-selected" : ""
														}`}
													>
														<Grid item style={{ width: "100%" }}>
															<Typography
																classes={classes.listItem}
																nowrap
																className="typography-ellipsis"
																onClick={() => {
																	handleReviewSelect(option?.id, true)
																	reviewSelectedCallback(true)
																}}
															>
																{option?.name}
															</Typography>
														</Grid>
														{/* <Grid>
														<span onClick={() => handleEditReview(option?.id)}>
															<EditIcon
																style={{ width: "16px", height: "16px", color: theme.palette.text.primary }}
															/>
														</span>
													</Grid> */}
													</MenuItem>
												))}
											</>
										) : (
											<ListItemText
												style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
												primary={t("review.noDataFound")}
											/>
										))}

									<Divider variant="fullWidth" className={classes.divider} />
									{isCaseAdmin && (
										<Typography
											onClick={(e) => {
												e.stopPropagation()
											}}
											className={classes.listTitle}
										>
											{t("review.assignedToYou")}
										</Typography>
									)}

									{!isListLoading && assignedToYou.length > 0 ? (
										<>
											{assignedToYou?.map((option, i) => (
												<MenuItem
													key={option?.id}
													value={option?.id}
													className={`${classes.list} qa-review-list-item-${i} ${
														selectedReview?.id === option?.id && !is_case_admin ? "Mui-selected" : ""
													}`}
												>
													<Grid item style={{ width: "100%" }}>
														<Typography
															classes={classes.listItem}
															nowrap
															className="typography-ellipsis"
															onClick={() => {
																handleReviewSelect(option?.id, false)
																reviewSelectedCallback(true)
															}}
														>
															{option?.name}
														</Typography>
													</Grid>
													{/* <Grid>
														<span onClick={() => handleEditReview(option?.id)}>
															<EditIcon
																style={{ width: "16px", height: "16px", color: theme.palette.text.primary }}
															/>
														</span>
													</Grid> */}
												</MenuItem>
											))}
										</>
									) : (
										<ListItemText
											style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
											primary={t("review.noDataFound")}
										/>
									)}
								</div>

								{isCaseAdmin && !hideCreateReviewButton && (
									<div className={classes.footer}>
										<Paper className={classes.card} elevation={0}>
											<Tooltip
												title={
													selectedReview?.id
														? t("review.reviewContex")
														: filesCount === 0
														? t("review.createDisabledMsg")
														: ""
												}
												placement="top"
												arrow
											>
												<span>
													<Button
														variant="text"
														fullWidth
														size="small"
														startIcon={<Add />}
														disableRipple
														className={classes.addReview}
														onClick={handleClick}
														disabled={filesCount === 0 || selectedReview?.id}
													>
														{t("review.create")}
													</Button>
												</span>
											</Tooltip>
										</Paper>
									</div>
								)}
							</>
						)}
					</Select>
					<Popper
						id={id}
						open={open}
						anchorEl={poperRef.current}
						transition
						placement="bottom-end"
						disablePortal={true}
						modifiers={{
							flip: {
								enabled: false,
							},
							preventOverflow: {
								enabled: true,
								boundariesElement: "window",
							},
							//gpuAcceleration: false,
						}}
						style={{ zIndex: 2 }}
					>
						{({ TransitionProps }) => (
							<Fade {...TransitionProps} timeout={350}>
								<Paper className={classes.createReview}>
									<ReviewForm
										onClose={handleClick}
										selectedSearch={selectedSearch}
										filesCount={filesCount}
										loadSavedSearch={loadSavedSearch}
										mapDataToState={mapDataToState}
									/>
								</Paper>
							</Fade>
						)}
					</Popper>
				</FormControl>
			</Box>
		</>
	)
}

export default ReviewDropdown
